import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import CreateDownloadFrom from './CreateDownloadFrom';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DownloadItemList from './DownloadItemList';
import { useDispatch, useSelector } from 'react-redux';
import { clearCurrentMovieInfo, getComaniesList, getCurrentMovieInfo } from 'redux/actions/Movies';
import { useLocation } from 'react-router';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
    marginBottom: 6,
  },
}));

const stateMap = {
  confirmed: 0,
  hidden: 1,
  pending: 2,
};

const CreateDownload = () => {
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);

  const movieId = params.get('download');
  const movieUid = params.get('ui');
  const movieName = params.get('name');
  const publishStatus = params.get('published');

  const { companiesList, currentMovie } = useSelector(({ movies }) => movies);

  useEffect(() => {
    dispatch(getComaniesList());
  }, [dispatch]);

  useEffect(() => {
    if (movieId !== 'null') {
      dispatch(getCurrentMovieInfo(movieId));
    } else {
      dispatch(clearCurrentMovieInfo());
    }
  }, [movieId, dispatch]);

  const breadcrumbs = [
    { label: 'لیست فیلم‌ها', link: '/' },
    { label: `مدیریت دانلود فیلم  ${movieName}`, isActive: true },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs} heading={`مدیریت دانلود فیلم  ${movieName}`}>
      <Card className={classes.cardRoot}>
        {movieId === 'null' ? (
          <CreateDownloadFrom companies={companiesList} movieUid={movieUid} published={stateMap[publishStatus]} />
        ) : (
          currentMovie && (
            <CreateDownloadFrom
              companies={companiesList}
              movieInfo={currentMovie}
              movieUid={movieUid}
              published={stateMap[publishStatus]}
            />
          )
        )}
      </Card>
      <DownloadItemList />
    </PageContainer>
  );
};

export default CreateDownload;
